import { DictionaryNaceCzAutocomplete, DictionaryNaceCz } from '../../models';
import {
  useAutocompleteSource,
  ApiFilterOperation,
  DetailMode,
  ResultDto,
} from '@eas/common-web';
import { EvidenceAPI } from '../../enums';
import { useState, useEffect } from 'react';

export function useNaceCzItems() {
  return useAutocompleteSource<DictionaryNaceCzAutocomplete>({
    url: EvidenceAPI.DICTIONARY_CZ_NACES + '/autocomplete',
    params: {
      filters: [
        {
          field: 'leaf',
          operation: ApiFilterOperation.EQ,
          value: true,
        },
      ],
    },
  });
}

export function useClearNaceFieldsOnInvalidNace(
  czNace?: DictionaryNaceCz,
  mode?: DetailMode,
  clearFields?: () => void
) {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const check = async () => {
      setLoading(true);

      const resp = await fetch(
        `${EvidenceAPI.DICTIONARY_CZ_NACES}/autocomplete`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            filters: [
              {
                field: 'leaf',
                operation: ApiFilterOperation.EQ,
                value: true,
              },
              {
                field: 'id',
                operation: ApiFilterOperation.EQ,
                value: czNace?.id,
              },
            ],
          }),
        }
      );
      if (resp.ok) {
        const json = (await resp.json()) as ResultDto<DictionaryNaceCz>;
        if (json.count < 1) {
          clearFields?.();
        }
        setChecked(true);
      }
      setLoading(false);
    };
    if (czNace?.id && mode === DetailMode.EDIT && !checked) {
      check();
    }
  }, [czNace?.id, clearFields, mode, checked]);
  return { loading };
}
